import { Experience } from "../Types/Exprience";

export const experiences: Experience[] = [
  {
    title: { en: "Senior Architect", da: "Senior Architect" },
    company: { en: "Netcompany", da: "Netcompany" },
    start: "Jan 2026",
    end: "Present",
    responsibilities: [
      {
        en: "Lead architectural decisions across projects, ensuring scalable and maintainable solutions.",
        da: "Leder arkitektoniske beslutninger på tværs af projekter og sikrer skalerbare og vedligeholdelsesvenlige løsninger."
      },
      {
        en: "Define technical roadmaps and align stakeholders on platform strategy.",
        da: "Definerer tekniske roadmaps og afstemmer interessenter om platformstrategi."
      },
      {
        en: "Mentor teams on clean architecture, quality standards, and best practices.",
        da: "Mentorerer teams i ren arkitektur, kvalitetsstandarder og best practices."
      }
    ]
  },
  {
    title: { en: "IT-Consultant", da: "IT-Konsulent" },
    company: { en: "Netcompany", da: "Netcompany" },
    start: "2023",
    end: "Dec 2025",
    responsibilities: [
      {
        en: "Designed and maintained RESTful services in C#/.NET Core for large-scale public sector platforms.",
        da: "Designede og vedligeholdt RESTful services i C#/.NET Core til store offentlige platforme."
      },
      {
        en: "Contributed to enterprise frontends built with React and Angular, focusing on scalability and maintainability.",
        da: "Bidrog til enterprise-frontends bygget i React og Angular med fokus på skalerbarhed og vedligeholdbarhed."
      },
      {
        en: "Served as Scrum Master, facilitating sprint planning, retrospectives, and ensuring smooth agile workflows.",
        da: "Fungerede som Scrum Master, faciliterede sprintplanlægning, retrospektiver og sikrede smidige agile processer."
      },
      {
        en: "Deployed microservices in containerized environments with Docker and Kubernetes as part of CI/CD pipelines.",
        da: "Deployede mikrotjenester i containeriserede miljøer med Docker og Kubernetes som en del af CI/CD-pipelines."
      },
      {
        en: "Built developer tooling to automate configuration and onboarding, reducing setup time and friction.",
        da: "Udviklede udviklerværktøjer til at automatisere konfiguration og onboarding, hvilket reducerede opsætningstid og friktion."
      },
      {
        en: "Main operator for business-critical systems, with focus on uptime, stability, and secure operations.",
        da: "Hoveforvalter for forretningskritiske systemer med fokus på oppetid, stabilitet og sikker drift."
      }
    ]
  },
  {
    title: { en: "Teaching Assistant", da: "Undervisningsassistent" },
    company: { en: "Technical University of Denmark", da: "Danmarks Tekniske Universitet" },
    start: "2021",
    end: "2021",
    responsibilities: [
      { en: "Database Systems (MySQL) – taught relational schema design and advanced SQL.", da: "Databasesystemer (MySQL) – underviste i relationsdesign og avanceret SQL." }
    ]
  },
  {
    title: { en: "Teaching Assistant", da: "Undervisningsassistent" },
    company: { en: "Technical University of Denmark", da: "Danmarks Tekniske Universitet" },
    start: "2020",
    end: "2022",
    responsibilities: [
      { en: "Introductory Programming – taught algorithmic thinking and Java basics.", da: "Introduktion til programmering – underviste i algoritmisk tænkning og Grundlæggende Java." }
    ]
  },
  {
    title: { en: "Teaching Assistant", da: "Undervisningsassistent" },
    company: { en: "Roskilde University", da: "Roskilde Universitet" },
    start: "2019",
    end: "2020",
    responsibilities: [
      { en: "Essential Computing – assisted students in fundamental computing and programming.", da: "Grundlæggende computing – assisterede studerende i basal programmering og computing." }
    ]
  }
];
